import { SRCSET_STEPS } from '@/Scripts/constants';
import GetSizes from '@/Scripts/lib/helper/imageSizesHelper.js';

function removeLastComma (str) {
  return str.replace(/,(\s+)?$/, '');
}
export default {
  data () {
    return {
      rootPath: 'https://res.cloudinary.com/norrona/image/upload/'
    };
  },
  methods: {
    imgSrcBuilder (obj, width, height, bgcolor, params = {}) {
      const crop = params.crop || 'c_pad';
      const quality = params.quality || 'q_auto';
      let filetype = params.filetype || 'jpg';
      const focalOn = params.focalOn || false;
      const focalSize = params.focalSize || 1;
      let border = '';
      if (params.scaleDownBy) {
        const borderWidth = width * (params.scaleDownBy / 100);
        border = bgcolor === 'transparent' ? `bo_${borderWidth}px_solid_transparent` : `bo_${borderWidth}px_solid_rgb:${bgcolor}`;
        width = width - borderWidth * 2;
        height = height - borderWidth * 2;
      }

      let format = 'f_auto';
      // VALIDATION
      if (!obj || (!obj.Path && !obj.Url)) {
        obj = {
          Url: '',
          Path: 'missing',
          Version: '',
          isPackShot: true
        };
      }
      if (bgcolor === 'transparent' && filetype !== 'gif') {
        filetype = 'png';
      }
      const defaultParam = 'd_imgmissing.jpg,fl_progressive.lossy';
      bgcolor = bgcolor.replace('#', '');
      // don't pass color if transparent
      bgcolor = bgcolor !== 'transparent' ? `b_rgb:${bgcolor}` : '';
      if (bgcolor !== '') {
        format = '';
      }
      // don't pass size if 0
      width = width > 0 ? `w_${Math.round(width)}` : '';
      height = height > 0 ? `h_${Math.round(height)}` : '';

      // generate settings order
      const settings = {
        bgcolor,
        crop,
        defaultParam,
        width,
        height,
        quality,
        format,
        border
      };

      // pass version if exist
      const version = obj.Version !== null && obj.Version.length ? `v${obj.Version}/` : '';

      const imgPath = obj.Path;
      // no cloudinary instance: do not manipulate url, and return the original
      if (!imgPath.length) {
        return encodeURI(obj.Url);
      }

      let returnPath = this.rootPath;
      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(settings)) {
        if (value !== '') {
          returnPath += value;
          returnPath += ',';
        }
      }
      let focalStr = '';
      if (focalOn && this.focal(focalSize).length > 0) {
        focalStr = this.focal(focalSize);
      }

      returnPath = removeLastComma(returnPath);
      returnPath += `/${focalStr}${version}${imgPath}.${filetype}`;
      return encodeURI(returnPath);
    },
    imgSrcsetBuilder (obj, bgcolor = this.Globals.colors.white, ratio = 0, params) {
      let str = '';
      for (let i = 0; i < SRCSET_STEPS.length; i++) {
        const step = SRCSET_STEPS[i];
        const width = Math.round(step);
        const height = width * ratio;
        const url = this.imgSrcBuilder(obj, width, height, bgcolor, params);
        str += `${url} ${SRCSET_STEPS[i]}w`;
        if (i < SRCSET_STEPS.length - 1) {
          str += ',';
        }
      }
      return str;
    },
    imageObjectBuilder (imageObject, backgroundColor, width, ratio, params = {}) {
      const image = {};
      image.class = params.class || '';
      image.description = params.description || '';
      image.src = this.imgSrcBuilder(imageObject, width, width * ratio, backgroundColor, params);
      image.srcset = this.imgSrcsetBuilder(imageObject, backgroundColor, ratio, params);
      image.sizes = params.sizes ? GetSizes(params.sizes) : null;
      image.ratio = ratio;
      return image;
    }
  }
};
